import React, { useEffect } from 'react';
import { getProductEntityName } from '../Product.config';
import { useAssignDesignOutputDesignSpec } from '../Product.hooks';

import {
  ProductDesignSpec,
  BaseProductAssignDialogProps
} from '../Product.interface';
import AssignDesignSpecDialog from './AssignDesignSpecDialog';

export type DesignOutputAssignDesignSpecDialogProps =
  BaseProductAssignDialogProps<'designOutputId'>;

const DesignOutputAssignDesignSpecDialog: React.FC<DesignOutputAssignDesignSpecDialogProps> =
  (props: DesignOutputAssignDesignSpecDialogProps) => {
    const {
      open,
      productId,
      designOutputId,
      selectedItems,
      onCancel,
      onError,
      onAssigned
    } = props;
    const {
      updatedProductDesignOutput,
      isAssigning,
      error: assignError,
      assignDesignSpecs
    } = useAssignDesignOutputDesignSpec(productId, designOutputId);

    // handle notification to parent after assigning
    useEffect(() => {
      if (updatedProductDesignOutput) {
        onAssigned?.(updatedProductDesignOutput);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [updatedProductDesignOutput]);

    useEffect(() => {
      if (assignError) {
        onError?.(assignError);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [assignError]);

    return (
      <AssignDesignSpecDialog
        {...{ open, productId, selectedItems, onCancel, onError }}
        isLoading={isAssigning}
        contentText={`Search for ${getProductEntityName(
          'designSpec'
        )} to assign to the ${getProductEntityName('designOutput')}.`}
        onSubmit={(designSpecs: ProductDesignSpec[]) => {
          assignDesignSpecs({
            designSpecIds: designSpecs.map(
              (designSpec: ProductDesignSpec) => designSpec.id
            )
          });
        }}
      />
    );
  };

export default DesignOutputAssignDesignSpecDialog;
